import { useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { JWT, ROUTES } from "../config/constants";
import { clearAllSessionStorage } from "../utils/sessionStorage";

/**
 * Custom hook untuk handle authentication dan project ID
 * @returns {Object} { projectID, projectName, isAdmin, forceLogout }
 */
export function useAuth() {
  const navigate = useNavigate();

  const forceLogout = () => {
    localStorage.removeItem(JWT.TOKEN_KEY);
    localStorage.removeItem(JWT.PROJECT_ID_KEY);
    localStorage.removeItem(JWT.PROJECT_NAME_KEY);
    localStorage.removeItem(JWT.NAMA_KEY);
    clearAllSessionStorage(); // Clear all cached data
    navigate(ROUTES.LOGIN);
  };

  const authData = useMemo(() => {
    const token = localStorage.getItem(JWT.TOKEN_KEY);
    const projectName = localStorage.getItem(JWT.PROJECT_NAME_KEY);

    if (!token) {
      return {
        projectID: null,
        projectName: null,
        isAdmin: false,
        userName: null,
      };
    }

    try {
      const decoded = jwtDecode(token);
      const raw = decoded.project_id;

      // Validasi project_id (optional - bisa kosong untuk lesson management)
      let projectID = null;
      if (raw && raw !== "" && !isNaN(Number(raw))) {
        projectID = Number(raw);
        localStorage.setItem("project_id", projectID);
      } else if (raw && raw !== "") {
        // Jika project_id adalah UUID string (bukan number), simpan sebagai string
        projectID = raw;
        localStorage.setItem("project_id", projectID);
      }
      // Jika kosong atau null, projectID tetap null (valid untuk lesson management)

      return {
        projectID,
        projectName: projectName || "No Project",
        isAdmin: decoded.is_admin === true,
        userName: localStorage.getItem(JWT.NAMA_KEY) || "No Username",
      };
    } catch (err) {
      console.error("Failed decoding token:", err);
      return {
        projectID: null,
        projectName: null,
        isAdmin: false,
        userName: null,
      };
    }
  }, []);

  return {
    ...authData,
    forceLogout,
  };
}
